class SearchNav extends HTMLElement {
  constructor() {
    super();
    this.tabs = this.querySelectorAll('[data-search-nav-tab]');
  }

  connectedCallback() {
    this.setActiveTab();
    this.getTabCounts();
  }

  setActiveTab() {
    this.tabs.forEach((tab) => {
      const type = tab.getAttribute('data-type');

      if (window.location.href.indexOf(type) >= 0 || type === 'product' && window.location.href.indexOf('type=') === -1) {
        tab.classList.add('active');
      } else {
        tab.classList.remove('active');
      }
    });
  }

  async getTabCounts() {
    for (let index = 0; index < this.tabs.length; index++) {
      const tab = this.tabs[index];
      const type = tab.getAttribute('data-type');
      const countElement = tab.querySelector('[data-search-nav-tab-count]');
      const params = new URLSearchParams(window.location.search);
      params.delete('type');
      params.delete('view');
      const view = type === 'article' ? '&view=articles' : '' || type === 'page' ? '&view=pages' : ''
      const url = `/search?${params}&type=${type}${view}`;
      const typeCount = await this.fetchSearch(url);
      countElement.innerText = typeCount;

      if (typeCount === 0) {
        tab.setAttribute('href', '#');
      } else {
        tab.setAttribute('href', url.replace('&type=product', ''));
      }

      if (type === 'product') {
        const searchProductsTotalCount = document.querySelectorAll('[data-search-products-count]');

        searchProductsTotalCount.forEach((count) => {
          count.innerText = typeCount;
        });
      }
    }

    const productTab = document.querySelector('[data-search-nav-tab][data-type="product"]');
    const productTabCountElement = productTab?.querySelector('[data-search-nav-tab-count]');

    if (productTab && productTabCountElement.innerText === '0' && window.location.href.indexOf('&view') === -1) {
      let tabSelected = false;

      this.tabs.forEach((tab) => {
        const type = tab.getAttribute('data-type');
        const countElement = tab.querySelector('[data-search-nav-tab-count]');

        if (type != 'product' && countElement.innerText != '0' && tabSelected === false) {
          tab.click();
          tabSelected = true;
        }
      });
    }
  }

  async fetchSearch(url) {
    const count = fetch(url,
    {
      credentials: "same-origin",
      method: "GET",
      headers: {
        "Cache-Control": "no-cache"
      }
    })
    .then(response => response.text())
    .then(text => {
      let count = 0;
      const searchNav = new DOMParser().parseFromString(text, 'text/html').querySelector('search-nav');

      if (searchNav) {
        count = searchNav.getAttribute('data-search-nav-total');
      }

      return count
    })
    .catch((error) => {
      console.error(error);
    });

    return count
  }
}

customElements.define('search-nav', SearchNav);